/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSetting, setLanguage } from "../../../actions/admin/settings";
import LanguageCard from "../../../components/layout-new-theme/LanguageCard";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ArrowRightIcon, CheckRoundedIcon } from "../../../components/icons";


const logo_brand_name = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-brand-name.svg";
const logo_brand = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-brand.svg";
const SuccessChangePaymentMethod = () => {
  const {  i18n } = useTranslation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  useEffect(() => {
    try {
      if (localStorage.getItem("lang") === undefined || localStorage.getItem("lang") === null) {
        var userLang = navigator.language || navigator.userLanguage;
        if (userLang === "ja") {
          langChange("JP");
        } else {
          langChange("EN");
        }
      }else{
        langChange(localStorage.getItem("lang"));
      }
    } catch { 
      console.log("error")
    }
  }, []);
  
   const langChange = (lng) => {
    i18n.changeLanguage(lng.toLowerCase());
    localStorage.setItem("lang", lng);
    dispatch(setLanguage(lng));
  };
  return (
    <>
      <div style={{ backgroundColor: "#F6F6F6" }} className="" >
        <nav className="tw:relative tw:flex tw:flex-wrap tw:sm:flex-nowrap tw:items-center tw:justify-between tw:sm:justify-start tw:py-2 tw:bg-[#212529] tw:sticky tw:top-0 tw:z-[1020]">
          <div className="tw:w-full tw:mx-auto tw:px-3 tw:flex tw:flex-wrap tw:items-center tw:justify-between">
            <div className="tw:block! tw:md:hidden!"></div>
            <img
              alt=""
              src={logo_brand}
              style={{ width: "70px", marginLeft: "100px" }}
              className="tw:py-[0.3125rem] tw:mr-4 tw:whitespace-nowrap tw:block! tw:md:hidden!"
            />
            <img
              alt=""
              src={logo_brand_name}
              style={{ width: "70px" }}
              className="tw:py-[0.3125rem] tw:mr-4 tw:whitespace-nowrap tw:hidden! tw:md:block!"
            />
            <LanguageCard />
          </div>
        </nav>
        <div className="custom-mx tw:mt-4 tw:pt-4 tw:sm:mt-12 tw:sm:pt-12">
          <div className="custom-mt-6 tw:w-full tw:mx-auto tw:px-3 tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-12 tw:md:pb-0 tw:pt-12 tw:md:pt-0">
            <div className="tw:flex tw:flex-wrap tw:-mx-3 tw:pb-12 tw:lg:justify-center">
              <div className="tw:w-full tw:md:w-2/3 tw:px-12 tw:py-12">
                <div className="tw:flex tw:flex-wrap tw:-mx-3 tw:mb-12">
                  {
                    <div className="tw:w-full tw:text-center tw:mb-4">
                      <CheckRoundedIcon />
                    </div>
                  }
                  <h3 className="tw:font-bold! tw:text-center tw:text-[#212529]! tw:my-4 tw:w-full">
                    {t("SuccessChangePaymentMethod.Title")}
                  </h3>
                  <p className="tw:text-center tw:mb-4 tw:w-full">
                    {t("SuccessChangePaymentMethod.Desc")}
                    <br />
                    <br />
                    <span dangerouslySetInnerHTML={{__html : t("SuccessChangePaymentMethod.Contact")}}></span>
                  </p>
                  <div className="tw:mt-4 tw:flex tw:justify-center tw:w-full">
                  <div className="tw:md:grid">
                  <button
                      type="button"
                      className="tw:inline-block tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:text-sm tw:py-1 tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:bg-[#d4b055] tw:border-[#d4b055] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:text-[#212529]! tw:px-12 tw:rounded-[0.375rem]"
                      onClick={() => history.push("/")}
                    >
                      <div className="tw:flex tw:justify-center tw:py-2 tw:px-12 tw:items-center">
                        <div>{t("SuccessChangePaymentMethod.BackToHome")}</div>
                        <i className="tw:pl-2">
                          <ArrowRightIcon color="#4A4A4A" size={24} />
                        </i>
                      </div>
                    </button>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessChangePaymentMethod;
